<template>
  <div class="catalog-product-skeleton">
    <div class="catalog-product-skeleton__image skeleton-shimmer"></div>

    <div class="catalog-product-skeleton__body">
      <div class="catalog-product-skeleton__brand skeleton-shimmer"></div>

      <div class="catalog-product-skeleton__name">
        <span class="catalog-product-skeleton__dot" aria-hidden="true"></span>
        <div class="catalog-product-skeleton__title-lines">
          <div class="catalog-product-skeleton__title skeleton-shimmer"></div>
          <div class="catalog-product-skeleton__title catalog-product-skeleton__title--short skeleton-shimmer"></div>
        </div>
      </div>

      <div class="catalog-product-skeleton__price-panel">
        <div class="catalog-product-skeleton__price skeleton-shimmer"></div>
        <div class="catalog-product-skeleton__badges">
          <div class="catalog-product-skeleton__badge skeleton-shimmer"></div>
          <div class="catalog-product-skeleton__badge catalog-product-skeleton__badge--wide skeleton-shimmer"></div>
        </div>
        <div class="catalog-product-skeleton__before skeleton-shimmer"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.catalog-product-skeleton {
  width: 100%;
  min-width: 0;
  height: 100%;
  min-height: 514px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #0b0b0b;
  border-radius: 12px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.35);
}

.catalog-product-skeleton__image {
  width: 100%;
  height: 300px;
  flex: 0 0 300px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.catalog-product-skeleton__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem;
  background: #0b0b0b;
}

.catalog-product-skeleton__brand {
  width: 42%;
  height: 0.72rem;
  border-radius: 4px;
  margin-bottom: 0.75rem;
}

.catalog-product-skeleton__name {
  display: grid;
  grid-template-columns: 7px minmax(0, 1fr);
  gap: 0.55rem;
  align-items: start;
  min-width: 0;
}

.catalog-product-skeleton__dot {
  width: 6px;
  height: 6px;
  margin-top: 0.42rem;
  border-radius: 50%;
  background: #e51f2f;
}

.catalog-product-skeleton__title-lines {
  min-width: 0;
}

.catalog-product-skeleton__title {
  width: 86%;
  height: 1.05rem;
  border-radius: 5px;
  margin-bottom: 0.5rem;
}

.catalog-product-skeleton__title--short {
  width: 58%;
}

.catalog-product-skeleton__price-panel {
  margin-top: 1.35rem;
  padding-top: 0.85rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.catalog-product-skeleton__price {
  width: 62%;
  height: 1.45rem;
  border-radius: 5px;
  margin-bottom: 0.65rem;
}

.catalog-product-skeleton__badges {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  min-height: 22px;
}

.catalog-product-skeleton__badge {
  width: 44px;
  height: 22px;
  border-radius: 999px;
}

.catalog-product-skeleton__badge--wide {
  width: 92px;
}

.catalog-product-skeleton__before {
  width: 48%;
  height: 0.78rem;
  border-radius: 4px;
  margin-top: 0.85rem;
  opacity: 0.7;
}

.skeleton-shimmer {
  background: linear-gradient(90deg, #171717 0%, #252525 50%, #171717 100%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.35s ease-in-out infinite;
}

@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@media (max-width: 767px) {
  .catalog-product-skeleton {
    min-height: 470px;
  }

  .catalog-product-skeleton__image {
    height: 260px;
    flex-basis: 260px;
  }
}
</style>
